import React from 'react';
import styled from 'styled-components';
import shortid from 'shortid';

import css from 'css';

export default ({ label, labelWhite, onChange, white, error, ...rest }) => {
    const id = shortid.generate();

    return (
        <Wrapper labelWhite={labelWhite ? 1 : 0} white={white ? 1 : 0} error={error} className={['checkbox-wrapper', error ? 'error' : ''].join(' ')}>
            <input id={id} type="checkbox" onChange={e => onChange(e)} {...rest} />
            <label htmlFor={id}>{label}</label>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    position: relative;
    
    input {
        position: absolute;
        z-index: -1;
        opacity: 0;
    }

    label {
        display: inline-flex;
        align-items: center;
        font-size: 20px;
        cursor: pointer;
        color: ${props => props.labelWhite ? '#fff' : ''};

        &:before {
            content: '';
            width: 24px;
            height: 24px;
            display: inline-block;
            border: 2px solid ${props => props.white ? '#fff' : css.colors.blue};
            background: ${props => props.white ? 'rgba(255,255,255,.3)' : 'transparent'};
            cursor: pointer;
            margin-right: 16px;

            @media (max-width: 768px) {
                width: 40px;
            }
        }

        &:hover:before {
            border: 2px solid ${props => props.white ? '#fff' : css.colors.black};
        }

        &:active:before {
            border: 2px solid ${props => props.white ? '#fff' : css.colors.black};
            background: ${props => props.white ? 'rgba(255,255,255,.3)' : 'transparent'} url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMjAgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYWdlIDEgQ29weTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJEZXNpZ24taW52ZW50b3J5IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iRm9ybS1lbGVtZW50cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUxNy4wMDAwMDAsIC0xOTMuMDAwMDAwKSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlBhZ2UtMS1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MjcuMDAwMDAwLCAxOTkuNTAwMDAwKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtNTI3LjAwMDAwMCwgLTE5OS41MDAwMDApICIgcG9pbnRzPSI1MjIgMTkxIDUzMiAyMDEuNzEyODMzIDUyNi4xOTc5OTggMjA4Ij48L3BvbHlsaW5lPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+') center center no-repeat;
        }
    }

    input:checked + label:before {
        border: 2px solid ${props => props.white ? '#fff' : css.colors.blue};
        background: ${props => props.white ? 'rgba(255,255,255,.3)' : css.colors.blue} url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTYgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QYWdlIDEgQ29weTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iY2hlY2tib3hfY2hlY2tlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuMDAwMDAwLCAtNy4wMDAwMDApIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGFnZS0xLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjAwMDAwMCwgMTIuNTAwMDAwKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTIuMDAwMDAwLCAtMTIuNTAwMDAwKSAiIHBvaW50cz0iNy41IDUuNSAxNi41IDE0LjMyMjMzMzIgMTEuMjc4MTk4MiAxOS41Ij48L3BvbHlsaW5lPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+') center center no-repeat;
    }

    ${props => props.error ? `
        &:after {
            content: '${props.error}';
            color: ${css.colors.red};
            display: block;
            position: absolute;
            left: 0;
            bottom: -25px;
        }
    ` : ``}
`



// WEBPACK FOOTER //
// ./src/partials/formElements/Checkbox.js